import { httpV1 as http } from '@/services/api';

export async function getPendingFormalization(params) {
  return http.get('/self-contracting/lead-pending-antifraud', { params });
}
